import {TransactionType} from "../../libs/enum/transaction-type.enum";
import {TransactionStatus} from "../../libs/enum/transaction-status.enum";
import {BilledFeature} from "../../libs/enum/billed-feature.enum";
import {AccAmountPipe} from "../../libs/pipes/amount.pipe";

export class OrgWalletTransactionDto implements AccAmountPipe {

  public readonly id!: string;
  public readonly transactionType!: TransactionType;
  public readonly billedFeature!: BilledFeature;
  public readonly updated!: Date;
  public readonly transactionStatus!: TransactionStatus;
  public readonly netAmount!: number;
  public readonly netBalance!: number;
  public readonly currencyCode!: string; // Enum: AccEntity

  constructor(init?: Partial<OrgWalletTransactionDto> | undefined) {
    Object.assign(this, init);
  }

  public isEditable(): boolean {
    return false;
  }

  // AccAmountPipe
  public getCurrencyCode(): string {
    return this.currencyCode;
  }

  // AccAmountPipe
  public getPreferCurrencyCode(): string | undefined {
    return undefined;
  }

  // AccAmountPipe
  public getFractionalDigits(): number {
    return 2;
  }
}
